import { useFeatureIsOn } from '@growthbook/growthbook-react'

import type { PageInfo } from '../../../../shared/types'
import { EditableCTAPanel } from '../../../home/components/EditableCTAPanel/EditableCTAPanel'
import { NewsFooterGam } from '../../../vertical/components/Gam/NewsFooterGam'
import { ArticlePageBodyGam, ArticlePageBodyOutOfPageGam } from '../Gam/ArticlePageBodyGam'
import { ArticlePageRhsGam } from '../Gam/ArticlePageRhsGam'
import { pppEnabledSubVerticals } from './PppEnabledSubVerticals'

type Props = {
  pageInfo: PageInfo
  panelLocation: 'articleFooter' | 'rightHandSide' | 'newsFooter'
  hideImageWhenNarrow?: boolean
}

export const PromoPanel = ({ pageInfo, panelLocation, hideImageWhenNarrow }: Props) => {
  const { sub_vertical } = pageInfo
  const pppEnabled = useFeatureIsOn('DSP-816-ppp-on-articles')

  const enabledForSubVertical = sub_vertical && pppEnabledSubVerticals.includes(sub_vertical)
  if (panelLocation === 'articleFooter') {
    if (!pppEnabled || !enabledForSubVertical) {
      return <ArticlePageBodyGam pageInfo={pageInfo} />
    }

    return (
      <>
        <EditableCTAPanel hideImageWhenNarrow={hideImageWhenNarrow} />
        <ArticlePageBodyOutOfPageGam pageInfo={pageInfo} />
      </>
    )
  }

  if (!pppEnabled || !enabledForSubVertical) {
    switch (panelLocation) {
      case 'rightHandSide':
        return <ArticlePageRhsGam pageInfo={pageInfo} />
      case 'newsFooter':
        return <NewsFooterGam pageInfo={pageInfo} />
      default:
        return null
    }
  }

  return <EditableCTAPanel hideImageWhenNarrow={hideImageWhenNarrow} />
}
